export default __webpack_public_path__ + "static/media/tour.85c09510.svg";